import Call from '../Call.v2';
import {objToQs} from "../Utils";

const ContentForYou = {
    get(filters = {}, type = 'daily') {
        return Call(`bidder/contentForYou/${type}?${objToQs(filters)}`);
    },
    affids(filters = {}, type = 'daily') {
        return Call(`bidder/contentForYou/affids/${type}?${objToQs(filters)}`);
    },
    sources(filters = {}, type = 'daily') {
        return Call(`bidder/contentForYou/sources/${type}?${objToQs(filters)}`);
    },
};

export default ContentForYou;


// WEBPACK FOOTER //
// ./src/services/API/components/ContentForYou.js